var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPopupInfoNewVersion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 35.0488,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 3.03125C23.4013 3.03125 3.03125 23.4013 3.03125 48.5C3.03125 73.5987 23.4013 93.9688 48.5 93.9688C73.5987 93.9688 93.9688 73.5987 93.9688 48.5C93.9688 23.4013 73.5987 3.03125 48.5 3.03125ZM48.5 75.7812C45.1656 75.7812 42.4375 73.0531 42.4375 69.7188C42.4375 66.3844 45.1656 63.6562 48.5 63.6562C51.8344 63.6562 54.5625 66.3844 54.5625 69.7188C54.5625 73.0531 51.8344 75.7812 48.5 75.7812ZM55.4416 28.7666L53.4106 53.0772C53.1984 55.6234 51.0766 57.5938 48.5 57.5938C45.9234 57.5938 43.8016 55.6234 43.5894 53.0772L41.5584 28.7666C41.225 24.7047 44.4078 21.2188 48.5 21.2188C52.38 21.2188 55.4719 24.3713 55.4719 28.1906C55.4719 28.3725 55.4719 28.5847 55.4416 28.7666V28.7666Z",
    fill: "url(#paint0_linear_3062_8699)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3062_8699",
    x1: 48.5,
    y1: 3.03125,
    x2: 48.5,
    y2: 93.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6DEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopupInfoNewVersion);
export default __webpack_public_path__ + "static/media/icon_popup_info_new_version.90ed743317e1b114c95c0865b2103e04.svg";
export { ForwardRef as ReactComponent };